import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class Camion extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'camion/one', saveUrl: 'camion/save', backUrl: '/Catalogo/Camiones' },
      new Form([
        Form.Field('text', 'camion_clave', 'Clave', '', [Validators.required], 6),
        Form.Field('text', 'camion_placas', 'Camion Placas', '', [Validators.required], 6),
        Form.Field('text', 'camion_modelo', 'Camion Modelo', '', [Validators.required], 6),
        Form.Field('text', 'camion_aseguradora', 'Nombre Aseguradora', '', [Validators.required], 6),
        Form.Field('text', 'camion_poliza_seguro', 'Poliza Seguro', '', [Validators.required], 6),
        Form.Field('select', 'id_transportista', 'Transportista', '', [Validators.required], 6),
        Form.Field('select', 'id_permiso_sct', 'Tipo Permiso SCT', '', [Validators.required], 6),
        Form.Field('text', 'camion_permiso_sct', 'Numero Permiso SCT', '', [Validators.required], 6),
        Form.Field('select', 'id_configuracion_vehicular', 'Config. Vehicular', '', [Validators.required], 12),
        Form.Field('number', 'PesoBrutoVehicular', 'Peso Bruto Vehicular(toneladas)', '', [Validators.required], 12),
      ], ['Guardar'], 'Camión'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  
  formData = async (form) => {
    let newForm = form;
    const Res = await Http.get(`camion/form`);

    if (!Res.error) {
      const { configAutotransportes, tipos_permiso, transportistas } = Res.data;
      if (configAutotransportes) {
        newForm = Form.FieldOptions(newForm, 'id_configuracion_vehicular', configAutotransportes, 'id', 'descripcion');
      }
      if (tipos_permiso) {
        newForm = Form.FieldOptions(newForm, 'id_permiso_sct', tipos_permiso, 'id', 'descripcion');
      }
      if (transportistas) {
        newForm = Form.FieldOptions(newForm, 'id_transportista', transportistas, 'id', 'transportista_nombre');
      }
    }

    return newForm;
  }
  

  render() {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mb-6">
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Camion)
